module.exports = __webpack_public_path__ + "static/media/pdp_foilRosegoldHover.79026f9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/pdp-hover/pdp_foilRosegoldHover.jpg
// module id = 1438
// module chunks = 50